import { motion } from "framer-motion";
import { formatCurrency } from "../../../data/mock/dashboardData";

const COLORS = ["#B91C1C", "#DC2626", "#347a62", "#c9a209", "#64748b"];

export default function PaymentMethodsChart({ methods: methodsProp } = {}) {
  const raw = Array.isArray(methodsProp) ? methodsProp : [];
  const total = raw.reduce((sum, m) => sum + (Number(m.amount) || 0), 0);
  const methods = raw
    .map((m, i) => {
      const amount = Number(m.amount) || 0;
      return {
        label: m.label || m.method || `Method ${i + 1}`,
        amount,
        pct: total > 0 ? Math.round((amount / total) * 100) : Number(m.pct) || 0,
        color: m.color || COLORS[i % COLORS.length],
      };
    })
    .filter((m) => m.amount > 0 || m.pct > 0);

  if (!methods.length) {
    return (
      <p className="flex min-h-[220px] flex-1 items-center justify-center text-sm text-primary/40">
        No payment method data yet.
      </p>
    );
  }

  return (
    <div className="flex h-full min-h-[220px] flex-1 flex-col justify-between">
      <div>
        <div className="flex h-5 overflow-hidden rounded-full">
          {methods.map((m, i) => (
            <motion.div
              key={m.label}
              className="h-full"
              style={{ backgroundColor: m.color }}
              initial={{ width: 0 }}
              animate={{ width: `${m.pct}%` }}
              transition={{ duration: 0.65, delay: 0.1 + i * 0.1, ease: "easeOut" }}
            />
          ))}
        </div>
        <p className="mt-2 text-center text-[11px] text-primary/40">
          Total collected · <span className="font-bold text-primary">{formatCurrency(total)}</span>
        </p>
      </div>

      <ul className="flex flex-1 flex-col justify-center space-y-3 py-2">
        {methods.map((m, i) => (
          <motion.li
            key={m.label}
            className="flex items-center justify-between gap-2"
            initial={{ opacity: 0, x: -6 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.25 + i * 0.08 }}
          >
            <span className="flex min-w-0 items-center gap-2">
              <span
                className="h-2.5 w-2.5 shrink-0 rounded-full"
                style={{ backgroundColor: m.color }}
              />
              <span className="truncate text-xs text-primary/60">{m.label}</span>
            </span>
            <span className="shrink-0 text-right">
              <span className="block text-xs font-bold text-primary">{m.pct}%</span>
              <span className="text-[10px] text-primary/35">{formatCurrency(m.amount)}</span>
            </span>
          </motion.li>
        ))}
      </ul>
    </div>
  );
}
